import { Component } from '@angular/core';
import { WizDropItemEvent } from '@wizeoo/akm-component-lib';

import { WIDGET_KIND } from '../../../model/enums';
import { PivotBasePop } from '../pivot/renderers/settings/pivot-base.pop';
import { PivotField } from '../../../manager/baselines/pivot-field.obj';

@Component({
  // popUp d'édition du Pivot : gestion des emplacements de champs, formules d'aggrégats et rendu
  selector: 'global-filter-settings-pop',
  templateUrl: './global-filter-settings.pop.html',
})
export class GlobalFilterSettingPop extends PivotBasePop {
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GLOBAL_FILTER; // le mode de cette pop, pour alimenter les PKD

  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: PivotField): boolean {

    return this.mainFilter.checkVisible(item);
  }

}
